import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Page';
import Header from './Header';
import Form from './Form';
import {useParams} from "react-router";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingTop: theme.spacing(3),
		paddingBottom: 100
	}
}));

const ParkingZoneGroupFormView = () => {
	const classes = useStyles();

	const {id} = useParams();

	return (
		<Page
			className={classes.root}
			title="Parking zone group"
		>
			<Container maxWidth="lg">
				<Header isNew={isNaN(id)}/>
				<Form />
			</Container>
		</Page>
	);
};

export default ParkingZoneGroupFormView;